import React from 'react';
import classes from './activity.module.css';

const Activity = ({activity}) => {    
    return (
        <div className={[classes.container,activity.filter === 'Past' && classes.PastActivity].join(" ")}>
            <div>
                <div className={classes.TitleContainer}>
                    <div className={classes.title}>{activity.type}</div>
                    <div className={classes.Status}>{activity.filter}</div>
                </div>
                <div className={classes.info}>Type : {activity.title ? activity.title : activity.type}</div>
                <div className={classes.TimeAndDate}>
                    <div className={classes.info}>Date : {activity.date}</div>
                    <div className={classes.info}>Time : {activity.time}</div>
                </div>
            </div>
            <div className={classes.divider}></div>
            <div>
                <div className={classes.subTitle}>Payment Details</div>
                <div className={classes.PaymentDetails}>
                    <div className={classes.label}>Total Amount:</div>
                    <div className={classes.amount}>{Math.round((activity.payment_details?.total_amount) * 1000) / 1000} JD</div>
                </div>
                <div className={classes.PaymentDetails}>
                    <div className={classes.label}>Payed Amount:</div>
                    <div className={classes.amount}>{Math.round((activity.payment_details?.paid_amount) * 1000) / 1000} JD</div>
                </div>
                <div className={classes.PaymentDetails}>
                    <div className={classes.label}>To Be Payed:</div>
                    <div className={`${classes.amount} ${classes.toBePayed}`}>{Math.round((activity?.payment_details?.remaining_amount) * 1000) / 1000} JD</div>
                </div>
            </div>
        </div>
    );
};

export default Activity;

